(function () {
  var KEY = 'ds_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }

  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function isWished(handle) {
    return getList().some(function (p) { return p.handle === handle; });
  }

  function toggle(handle, meta) {
    var list = getList();
    var idx  = list.findIndex(function (p) { return p.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(meta);
    }
    saveList(list);
    return idx === -1; // true = added
  }

  function syncBtn(btn) {
    var handle = btn.dataset.wlHandle;
    btn.classList.toggle('is-wished', isWished(handle));
    btn.setAttribute('aria-label', isWished(handle) ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initBtn(btn) {
    syncBtn(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.dataset.wlHandle;
      var meta   = {
        handle: handle,
        title:  btn.dataset.wlTitle,
        image:  btn.dataset.wlImage,
        price:  btn.dataset.wlPrice,
        url:    btn.dataset.wlUrl
      };
      var added = toggle(handle, meta);
      btn.classList.toggle('is-wished', added);
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');

      // update wishlist page if open
      document.dispatchEvent(new CustomEvent('ds:wishlist:change'));
    });
  }

  function initAll() {
    document.querySelectorAll('.ds-wl-btn').forEach(initBtn);
  }

  // init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // re-init after Shopify section renders (theme editor)
  document.addEventListener('shopify:section:load', initAll);

  // expose API globally for wishlist page
  window.DSWishlist = {
    getList:  getList,
    isWished: isWished,
    toggle:   toggle,
    initBtn:  initBtn
  };
})();
